import { makeStyles } from '@material-ui/core';

const useCustomLoadingStyles = makeStyles((theme) => {
    return({
        customLoadingBox: {
            display: 'flex',
            flexDirection: 'column',
            padding: '16px !important',
            boxShadow: '0px 11px 15px 0px rgba(0, 0, 0, 0.20), 0px 9px 46px 0px rgba(0, 0, 0, 0.12), 0px 24px 38px 0px rgba(0, 0, 0, 0.14)'
        },
    });
});

export default useCustomLoadingStyles;
